import { render, staticRenderFns } from "./ImportOrder.vue?vue&type=template&id=2fa8512e&"
import script from "./ImportOrder.vue?vue&type=script&lang=js&"
export * from "./ImportOrder.vue?vue&type=script&lang=js&"
import style0 from "./ImportOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports